import { useWeb3 } from '@/hooks/use-web3';
import { PoolListType, StatusGetPoolDetailsCall } from '@/types';
import { Fragment, useEffect, useRef, useState } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import PoolsCard from './card/PoolsCard';
import CommonButton from './CommonButton';
import { poolList } from '@/api/staking/read';
import { useWeb3AuthConnect } from '@web3auth/modal/react';

export default function Pools({ pools }: { pools: string[] }) {
  const address = useRef<string>('');
  const { isConnected } = useWeb3AuthConnect();
  const { web3authCall, address: addr } = useWeb3();
  const [lists, setLists] = useState<StatusGetPoolDetailsCall | null>(null);
  // const [lists, setLists] = useState<any | null>(null);
  const [isClosedView, setIsClosedView] = useState(false);
  // theme
  const theme = useTheme();

  useEffect(() => {
    if (address.current) {
      return;
    }
    (async () => {
      if (isConnected && addr) {
        address.current = addr;
        // privateList = await ownPrivateToken(addr);
      } else {
        // privateList = emptyPrivateAddress();
      }
      // const pools = await getAllPools();
      /**
       * private 토큰을 보유하고 있는지 체크
       * 프라이빗 풀이 5개 있다. 1~5
       * 지갑 주소에 해당 erc20 토큰이 있는지 체크
       * erc20토큰과 컨트랙트 풀 매칭시켜야 함,
       * 결과값은 배열로 풀 가져오기
       * erc20 1,2,3,4,5
       */
    })();
    return () => {};
  }, [web3authCall, isConnected, addr]);

  useEffect(() => {
    if (!pools) {
      return;
    }
    setAssetList();

    return () => {};
  }, []);

  const setAssetList = async () => {
    setLists(await poolList());
    // privateList null === 일반회원
    // const { arrFactoryPoolDetails, arrState } = promiseSetting(web3authCall, aPools);
    // const { arrFactoryDetails, state } = await promiseExcute(arrFactoryPoolDetails, arrState);
    // const mergedArray = arrFactoryDetails
    //   .map((item: ResGetPoolDetailsCall, index) => ({
    //     ...item,
    //     status: StateFilter(state[index]),
    //     statusIndex: state[index],
    //     contractAddr: aPools[index],
    //   }))
    //   // .filter((item: ResGetPoolDetailsCall) => !aPrivateList?.includes(item.contractAddr!))
    //   .reduce((acc, item) => {
    //     let key = reducePoolStatus(item.statusIndex);
    //     return reduceCheckAndPushKey(acc, key, item);
    //   }, {});

    // setLists(mergedArray);
  };

  return (
    <>
      {/* Open Pools */}
      <Box
        sx={{
          padding: { xs: '16px 24px', md: '20px 24px' },
          maxWidth: '1680px',
        }}
      >
        <Box>
          <Typography color={theme.greyscale.darkgrey2} variant={'h2'}>
            Open Pools
          </Typography>
        </Box>
        <Box
          sx={{
            paddingTop: '16px',
            display: 'flex',
            flexDirection: 'column',
            gap: {
              xs: '16px',
              md: '10px',
            },
          }}
        >
          {/* 특정 화면에서 풀 숨김 0x53f10a5e4736225ae5d00dD54ae4Fd0D6a855195 */}
          {lists?.open &&
            lists.open.map((item: PoolListType, index: number) => (
              <Fragment key={index}>
                <PoolsCard item={item} type="open" />
              </Fragment>
            ))}
        </Box>
      </Box>
      {/* Closed Pools */}
      <Box
        sx={{
          padding: { xs: '16px 24px', md: '20px 24px' },
          maxWidth: '1680px',
        }}
      >
        <Box>
          <Typography color={theme.greyscale.darkgrey2} variant={'h2'}>
            Closed Pools
          </Typography>
        </Box>
        <Box
          sx={{
            paddingTop: '16px',
            display: 'flex',
            flexDirection: 'column',
            gap: {
              xs: '16px',
              md: '10px',
            },
          }}
        >
          {lists?.closed &&
            lists.closed.map((item: PoolListType, index: number) =>
              index > 5 ? (
                ''
              ) : (
                <Fragment key={index}>
                  <PoolsCard item={item} type="closed" />
                </Fragment>
              ),
            )}
          {lists?.closed !== undefined && lists?.closed.length > 5 && (
            <>
              {/* PC - View Archived Pools */}
              <Typography
                sx={{
                  display: {
                    xs: 'none',
                    md: 'block',
                  },
                  cursor: 'pointer',
                }}
                variant="body3"
                color={theme.greyscale.grey2}
                onClick={() => {
                  setIsClosedView(true);
                }}
              >
                {'View Archived Pools >'}
              </Typography>
              {/* Mobile - View Archived Pools */}
              <CommonButton
                sx={{
                  display: {
                    xs: 'block',
                    md: 'none',
                  },
                  borderRadius: '10px',
                  height: '48px',
                  marginBottom: '55px',
                }}
                color={'#ffffff'}
                bgColor={theme.brand.primary}
                text={'View Archived Pools'}
                handleClick={() => {
                  setIsClosedView(true);
                }}
                variant={'subtitle1'}
              />
              {isClosedView &&
                lists?.closed &&
                lists.closed.map((item: PoolListType, index: number) =>
                  index > 5 ? (
                    <Fragment key={index}>
                      <PoolsCard item={item} type="closed" />
                    </Fragment>
                  ) : (
                    ''
                  ),
                )}
            </>
          )}
        </Box>
      </Box>
    </>
  );
}
